<template>
  <apm-bank-transfer v-if="isFurikomi" />
  <tile class='opc-succezz-order' v-else-if='isShowOrderDetails'>
    <h2 class='text-capitalize opc-succezz-order__summary' :aria-label="$t('billing.order_summary')">{{ $t('billing.order_summary') }}</h2>
    <div class='opc-succezz-order__details'>
      <div class='opc-succezz-order__details__cart' v-html='cartEle' />
      <div class='opc-succezz-order__details__total' v-html='totalEle' />
    </div>
    <div class='opc-succezz-order__expand'>
      <slot />
    </div>
  </tile>
</template>

<script>
import Tile from '@/components/tile.vue';
import { mapGetters } from 'vuex';
import { replaceELement } from '@/views/succezz/utils';
import ApmBankTransfer from '@/views/succezz/apm/apm-bank-transfer.vue';
import { subscriptionLevelActionEnum, couponTypes } from '@/views/config/coupon/helper/constant';
import { APM_PAYMENT_METHODS } from '@/common/constants';

export default {
  components: {
    Tile, ApmBankTransfer
  },
  computed: {
    ...mapGetters(['persistState', 'couponState']),
    isFurikomi() {
      return !!this.persistState.confirmationDetails?.isAPM && this.persistState.confirmationDetails?.apmName === APM_PAYMENT_METHODS.FURIKOMI
    },
    isShowOrderDetails() {
      return !!this.cartEle;
    },
    isPrecise() {
      return this.persistState.confirmationDetails?.isPrecise;
    },
    cartEle() {
      return this.persistState?.confirmationDetails?.cartEle;
    },
    submitELe() {
      const html = this.persistState?.confirmationDetails?.submitEle;
      if (!html) return false;
      return html + `<div class='opc-cart__main__divider'></div>`;
    },
    isInsertTotalEle() {
      if (!this.submitELe) return false;
      if (this.persistState.confirmationDetails?.onSessionPaymentEnabled) return false;
      return this.persistState.confirmationDetails?.discountWithAmountMap?.totalDiscount > 0;
    },
    totalEle() {
      let html = this.persistState?.confirmationDetails?.totalEle;
      if (this.isPrecise) {
        const tempEle = document.createElement('div');
        tempEle.innerHTML = html;

        replaceELement(tempEle, '.__PLACEHOLDER_total__tax', this.$t('billing.success.confirmation.tax_title'));
        replaceELement(tempEle, '.__PLACEHOLDER_total__today', this.$t('billing.order_summary.todays_total'));
        replaceELement(tempEle, '.__PLACEHOLDER_total__desc', ''); // disclaimer

        html = tempEle.innerHTML;
      }
      // replace coupon case
      if (this.isInsertTotalEle && (this.couponState.subscriptionLevelAction === subscriptionLevelActionEnum.replaceSubscription
        || (this.couponState.couponType === couponTypes.TIMEBASE && !(this.$context.is.buyNow || this.$context.is.basic2pro)))) {
        const tempEle = document.createElement('div');
        tempEle.innerHTML = html;
        const ele = tempEle.querySelector('.__PLACEHOLDER_0__');
        ele.innerHTML = this.submitELe;
        ele.style.display = 'block';
        ele.classList.add('opc-cart__submit__label');
        html = tempEle.innerHTML;
      }
      return html;
    },
  },
};
</script>

<style lang='scss'>
@import "@/views/config/shopping-cart/index.scss";
@import "@/views/config/shopping-cart/total.scss";
@import "@/views/config/shopping-cart/description.scss";
@import "@/views/config/shopping-cart/next-scope.scss";
@import "@/views/config/shopping-cart/next.scss";
@import "@/views/config/shopping-cart/prorated-charge";

.opc-cart__description {
  margin: 24px 0;
}
</style>

<style scoped lang='scss'>
.opc-succezz-order {
  &__details {
    border-top: 1px solid #dfdfe4;
    padding-top: 18px;
    margin-top: 18px;
  }

  /deep/ .__PLACEHOLDER_coupon__ {
    display: none;
  }

  /deep/ .zm-button:not(.opc-success-no-hide-button) {
    display: none;
  }

  /deep/ .zm-tooltip {
    display: none;
  }

  &__expand {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .opc-succezz-order__summary {
    font-size: 24px;
    font-weight: 500;
  }

  /deep/ .opc-cart-item__title .opc-cart-item__value {
    padding-left: 24px;
  }
}
</style>
